import { render, staticRenderFns } from "./OauthClientHeader.vue?vue&type=template&id=49304381"
import script from "./OauthClientHeader.vue?vue&type=script&lang=js"
export * from "./OauthClientHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports